parseYearResult